export const GlobalSettings = {
    maskValue: (localStorage.currency!==undefined && localStorage.currency==='OMR' )?'separator.3':'separator.2'
}